import { ModalTypes, ThemeTypes, RenderTypes } from '../Constants';
import Alert from './BlueTheme/Alert.cssmodule.less';
import Complete from './BlueTheme/Complete.cssmodule.less';
import Project from './BlueTheme/Project.cssmodule.less';
import Confirm from './BlueTheme/Confirm.cssmodule.less';
import ListTransfer from './BlueTheme/ListTransfer.cssmodule.less';
import LectureProgress from './BlueTheme/LectureProgress.cssmodule.less';
import LectureProgress2 from './BlueTheme/LectureProgress2.cssmodule.less';
import TextBookLectureProgress from './BlueTheme/TextBookLectureProgress.cssmodule.less';
import LectureIndicator from './BlueTheme/LectureIndicator.cssmodule.less';
import Curriculum from './BlueTheme/Curriculum.cssmodule.less';
import PopupList from './BlueTheme/PopupList.cssmodule.less';
import HardwareDownload from './BlueTheme/HardwareDownload.cssmodule.less';
import CP2017S2Maze from './CP2017S2/Maze.cssmodule.less';
import CP2017S2Diary from './CP2017S2/Diary.cssmodule.less';
import CP2017S2MazeResult from './CP2017S2/MazeResult.cssmodule.less';
import LineAlert from './LineTheme/Alert.cssmodule.less';
import LineComplete from './LineTheme/Complete.cssmodule.less';
import LineProject from './LineTheme/Project.cssmodule.less';
import LineConfirm from './LineTheme/Confirm.cssmodule.less';
import LineListTransfer from './LineTheme/ListTransfer.cssmodule.less';
import LineLectureProgress from './LineTheme/LectureProgress.cssmodule.less';
import LineLectureIndicator from './LineTheme/LectureIndicator.cssmodule.less';
import LineCurriculum from './LineTheme/Curriculum.cssmodule.less';
import LinePopupList from './LineTheme/PopupList.cssmodule.less';
import LineHardwareDownload from './LineTheme/HardwareDownload.cssmodule.less';
import LineSimplePopup from './LineTheme/Simple.cssmodule.less';
import SimplePopup from './BlueTheme/Simple.cssmodule.less';
import HintList from './BlueTheme/HintList.cssmodule.less';
import StudyGoal from './BlueTheme/StudyGoal.cssmodule.less';

export default {
    [ThemeTypes.BLUE]: {
        [ModalTypes.ALERT]: Alert,
        [ModalTypes.COMPLETE]: Complete,
        [ModalTypes.PROJECT]: Project,
        [ModalTypes.CONFIRM]: Confirm,
        [ModalTypes.LECTURE_PROGRESS]: LectureProgress,
        [ModalTypes.LECTURE_PROGRESS2]: LectureProgress2,
        [ModalTypes.TEXTBOOK_LECTURE_PROGRESS]: TextBookLectureProgress,
        [ModalTypes.LIST_EXPORT]: ListTransfer,
        [ModalTypes.LIST_IMPORT]: ListTransfer,
        [ModalTypes.HARDWARE_DOWNLOAD]: HardwareDownload,
        [ModalTypes.CURRICULUM_ALERT]: Curriculum,
        [ModalTypes.CURRICULUM_HINT]: Curriculum,
        [ModalTypes.SIMPLE]: SimplePopup,
        [ModalTypes.STUDY_GOAL]: StudyGoal,
        [RenderTypes.LECTURE_INDICATOR]: LectureIndicator,
        [RenderTypes.POPUP_LIST]: PopupList,
        [RenderTypes.HintList]: HintList,
    },
    [ThemeTypes.CP2017S2]: {
        [ModalTypes.MAZE]: CP2017S2Maze,
        [ModalTypes.DIARY]: CP2017S2Diary,
        [ModalTypes.MAZE_RESULT]: CP2017S2MazeResult,
    },
    [ThemeTypes.LINE]: {
        [ModalTypes.ALERT]: LineAlert,
        [ModalTypes.COMPLETE]: LineComplete,
        [ModalTypes.PROJECT]: LineProject,
        [ModalTypes.CONFIRM]: LineConfirm,
        [ModalTypes.LECTURE_PROGRESS]: LineLectureProgress,
        [ModalTypes.LIST_EXPORT]: LineListTransfer,
        [ModalTypes.LIST_IMPORT]: LineListTransfer,
        [ModalTypes.HARDWARE_DOWNLOAD]: LineHardwareDownload,
        [ModalTypes.CURRICULUM_ALERT]: LineCurriculum,
        [ModalTypes.CURRICULUM_HINT]: LineCurriculum,
        [ModalTypes.SIMPLE]: LineSimplePopup,
        [RenderTypes.LECTURE_INDICATOR]: LineLectureIndicator,
        [RenderTypes.POPUP_LIST]: LinePopupList,
    },
};



// WEBPACK FOOTER //
// ./themes/index.js